// extracted by mini-css-extract-plugin
module.exports = {"Input":"Checkbox_Input__1wuJT","Checkbox":"Checkbox_Checkbox__1uS0h","Label":"Checkbox_Label__lwI_v"};